export const CREDIT_NOTES_FILTERS = [
    { label: 'Awaiting Credit', value: 'awaiting_credit' },
    // { label: 'Issued Credit Notes', value: 'issued' },
    { label: 'Received Credit Notes', value: 'received_credit' },
    { label: 'Used Credit Notes', value: 'used_credit' },
]